export const C_PERTENECE = {
  Aprocovici: {
    label: "APROCOVICI",
    value: "aprocovici"
  },
  Acoprovi: {
    label: "ACOPROVI",
    value: "acoprovi"
  },
  Ninguna: {
    label: "Ninguna",
    value: "ninguna"
  }
};

export const A_APROCOVICI = [
  C_PERTENECE.Acoprovi,
  C_PERTENECE.Aprocovici,
  C_PERTENECE.Ninguna
];
